import Icon from '../components/Icon.vue'

Icon.register({
  'sort-amount-up-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M240 96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-64zM240 224c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-128zM496 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-256c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h256zM240 352c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-192zM16 160c-14.2 0-21.3-17.3-11.3-27.3l80-96c2.6-2.6 7.7-4.7 11.3-4.7s8.7 2.1 11.3 4.7l80 96c10.1 10.1 2.9 27.3-11.3 27.3h-48v304c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-304h-48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-amount-up-alt.js
// module id = 1922
// module chunks = 0